import {TaskManagerContentComponent} from './components/task-manager-content/task-manager.component';
import {TaskDetailComponent} from './components/task-detail/task-detail.component';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {TaskAttachmentsComponent} from './components/task-attachments/task-attachments.component';
import {CompanyInfoComponent} from './components/company-info/company-info.component';
import {TaskAlertComponent} from './components/task-alert/task-alert.component';
import {TaskAssigneeComponent} from './components/task-assignee/task-assignee.component';
import {TaskSelectorComponent} from './components/task-selector/task-selector.component';
import {AddBoardDialogComponent} from './components/add-board-dialog/add-board-dialog.component';
import {TaskManagementDetailComponent} from './components/task-management-detail/task-management-detail.component';
import {TaskChecklistComponent} from './components/task-checklist/task-checklist.component';
import {TaskSubTicketsComponent} from './components/task-sub-tickets/task-sub-tickets.component';
import {TaskTitleComponent} from './components/task-title/task-title.component';
import {TaskOccurrenceComponent} from './components/task-occurrence/task-occurrence.component';
import {TaskCommentComponent} from './components/task-comment/task-comment.component';
import {AddColumnDialogComponent} from './components/add-column-dialog/add-column-dialog.component';
import {TaskCellViewerComponent} from './components/cell-viewers/task-cell-viewer/task-cell-viewer.component';
import {AddLinkDialogComponent} from './components/add-link-dialog/add-link-dialog.component';
import {StartDemoComponent} from './components/start-demo/start-demo.component';
import {EndDemoComponent} from './components/end-demo/end-demo.component';
import {StatusSettingsDialogComponent} from './components/status-settings-dialog/status-settings-dialog.component';
import {HelpNotesComponent} from './collaboration/components/help-notes/help-notes.component';
import {TaskAutoCreateCellViewerComponent} from './components/cell-viewers/task-auto-create-cell-viewer/task-auto-create-cell-viewer.component';
import {TaskAlertSendNotificationNowGridComponent} from './components/task-alert-send-notification-now-grid/task-alert-send-notification-now-grid.component';
import {ActivityFilterDateRangeSelectorComponent} from './collaboration/components/ActivityTracker/selector-dialogs/activity-filter-date-range-selector/activity-filter-date-range-selector.component';
import {TaskRoleComponent} from '@features/task-manager/components/task-role/task-role.component';
import {TaskComponent} from '@features/task-manager/components/task/task.component';
import {TaskHeaderComponent} from '@features/task-manager/components/task-header/task-header.component';
import {TaskBodyComponent} from '@features/task-manager/components/task-body/task-body.component';
import {TaskToolbarComponent} from '@features/task-manager/components/task-toolbar/task-toolbar.component';
import {TaskBodyDefaultViewComponent} from '@features/task-manager/components/task-body-default-view/task-body-default-view.component';
import { TaskDetailViewComponent } from './components/task-detail-view/task-detail-view.component';
import {TaskViewRightBarComponent} from '@features/task-manager/components/task-view-right-bar/task-view-right-bar.component';
import {TaskSubTicketViewComponent} from '@features/task-manager/components/task-sub-ticket-view/task-sub-ticket-view.component';
import {TaskDescriptionComponent} from '@features/task-manager/components/task-description/task-description.component';
import {DumpDemoDataComponent} from '@features/task-manager/components/dump-demo-data/dump-demo-data.component';
import {MapCompanyCellViewerComponent} from "@features/admin-panel/components/map-company-cell-viewer/map-company-cell-viewer.component";
import {XatbotArticleCellViewerComponent} from "@features/task-manager/components/xatbot-article-cell-viewer/xatbot-article-cell-viewer.component";

// @dynamic
export class TaskManagerDynamicComponentHelper {
  public static components: any;

  public static init() {
    if (TaskManagerDynamicComponentHelper.components) {
      return;
    }
    const components = {};

    components['HelpNotesComponent'] = HelpNotesComponent;
    components['TaskDetailComponent'] = TaskDetailComponent;
    components['TaskDetailViewComponent'] = TaskDetailViewComponent;
    components['TaskManagerContentComponent'] = TaskManagerContentComponent;
    components['TaskManagementDetailComponent'] = TaskManagementDetailComponent;
    components['TaskAttachmentsComponent'] = TaskAttachmentsComponent;
    components['CompanyInfoComponent'] = CompanyInfoComponent;
    components['TaskAssigneeComponent'] = TaskAssigneeComponent;
    components['TaskRoleComponent'] = TaskRoleComponent;
    components['TaskAlertComponent'] = TaskAlertComponent;
    components['TaskSelectorComponent'] = TaskSelectorComponent;
    components['AddBoardDialogComponent'] = AddBoardDialogComponent;
    components['AddColumnDialogComponent'] = AddColumnDialogComponent;
    components['TaskChecklistComponent'] = TaskChecklistComponent;
    components['TaskSubTicketsComponent'] = TaskSubTicketsComponent;
    components['TaskTitleComponent'] = TaskTitleComponent;
    components['TaskOccurrenceComponent'] = TaskOccurrenceComponent;
    components['TaskCommentComponent'] = TaskCommentComponent;
    components['TaskCellViewerComponent'] = TaskCellViewerComponent;
    components['AddLinkDialogComponent'] = AddLinkDialogComponent;
    components['StartDemoComponent'] = StartDemoComponent;
    components['EndDemoComponent'] = EndDemoComponent;
    components['DumpDemoDataComponent'] = DumpDemoDataComponent;
    components['StatusSettingsDialogComponent'] = StatusSettingsDialogComponent;
    components['TaskAutoCreateCellViewerComponent'] = TaskAutoCreateCellViewerComponent;
    components['TaskAlertSendNotificationNowGridComponent'] = TaskAlertSendNotificationNowGridComponent;
    components['DateRangeSelector'] = ActivityFilterDateRangeSelectorComponent;
    components['TaskComponent'] = TaskComponent;
    components['TaskHeaderComponent'] = TaskHeaderComponent;
    components['TaskBodyComponent'] = TaskBodyComponent;
    components['TaskToolbarComponent'] = TaskToolbarComponent;
    components['TaskBodyDefaultViewComponent'] = TaskBodyDefaultViewComponent;
    components['TaskViewRightBarComponent'] = TaskViewRightBarComponent;
    components['TaskSubTicketViewComponent'] = TaskSubTicketViewComponent;
    components['TaskDescriptionComponent'] = TaskDescriptionComponent;
    components['XatbotArticleCellViewerComponent'] = XatbotArticleCellViewerComponent;

    TaskManagerDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static getComponentArray(): any[] {
    TaskManagerDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(TaskManagerDynamicComponentHelper.components).forEach(key => {
      componentArray.push(TaskManagerDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
